import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines conditional classes and resolves Tailwind utility conflicts so a
 * caller's `className` override is deterministic.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
